<script lang="ts" context="module">
  export const resetPasswordModal = new ModalState('reset');
</script>

<script lang="ts">
  import Close from '~icons/mdi/close';
  import Send from '~icons/mdi/send';

  import ActionButton from '~/components/ActionButton.svelte';
  import Modal from '~/components/Modal.svelte';
  import { resetPasswordMutation } from './mutations.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import ValidationError from './ValidationError.svelte';
  import LockIcon from '~icons/feather/lock';
  import { validateEmail } from './utils';
  import type { ChangeEventHandler } from 'svelte/elements';
  import { toast } from 'svelte-sonner';

  const resetPassword = resetPasswordMutation();
  let emailRef: HTMLInputElement;
  let validationError: string | undefined = undefined;

  // const handleBack = () => {
  //   signinModal.replace();
  // }

  const handleClose = () => {
    resetPassword.reset();
    resetPasswordModal.pop();
  };

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    validationError = validateEmail((e.target as HTMLInputElement).value);
  };

  const handleReset = async (e: SubmitEvent) => {
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    const email = formData.get('email') as string;
    validationError = validateEmail(email);
    if (validationError) return;
    try {
      await resetPassword.mutateAsync(email);
      resetPasswordModal.pop();
      toast.success('sent');
    } catch {
      toast.error('error');
    }
  };
</script>

<Modal
  open={resetPasswordModal.value !== undefined}
  onClose={handleClose}
  index={7}
>
  {#snippet title()}
    <LockIcon />Reset Password
  {/snippet}
  {#snippet content()}
      <p>
        Don't remember your password? Send a reset link to the email you used to
        signup.
      </p>
      {#if resetPassword.error}
        <ValidationError error={resetPassword.error.message} />
      {:else if validationError}
        <ValidationError error={validationError} />
      {/if}
      <form
        id="reset-password-form"
        class="auth-form"
        novalidate
        on:submit|preventDefault={handleReset}
      >
        <input
          bind:this={emailRef}
          on:change={handleChange}
          type="email"
          name="email"
          placeholder="email"
          class:invalid={!!validationError}
          value={resetPasswordModal.value}
        />
      </form>
  {/snippet}
  {#snippet controls()}
    <div class="signup-container">
      {#if resetPassword.isSuccess}
        <ActionButton onClick={handleClose}><Close />Close</ActionButton>
      {:else}
        <ActionButton onClick={handleClose}><Close />Back</ActionButton>
        <ActionButton
          form="reset-password-form"
          type="submit"
          disabled={resetPassword.isPending}
          ><Send />
          {#if resetPassword.isPending}
            Sending...
          {:else}
            Send Email
          {/if}
        </ActionButton>
      {/if}
    </div>
  {/snippet}
</Modal>

<style lang="scss">
  @use '../theme/theme.scss';
  @use 'sass:color';

  .signup-container {
    display: grid;
    grid-auto-flow: column;
    gap: 0.5em;
  }
</style>
